import { Tabs, TabsContent, TabsList, TabsTrigger } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function TabsDemo() {
  return (
    <Section
      id="tabs"
      title="Tabs"
      description="Tabbed-panel container. Horizontal or vertical."
    >
      <VariantBlock label="Default">
        <Tabs defaultValue="overview" className="w-[420px]">
          <TabsList>
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="settings">Settings</TabsTrigger>
            <TabsTrigger value="team">Team</TabsTrigger>
          </TabsList>
          <TabsContent value="overview" className="pt-4 text-sm">
            High-level metrics for this workspace.
          </TabsContent>
          <TabsContent value="settings" className="pt-4 text-sm">
            Per-workspace settings and integrations.
          </TabsContent>
          <TabsContent value="team" className="pt-4 text-sm">
            Members, roles, and pending invites.
          </TabsContent>
        </Tabs>
      </VariantBlock>

      <VariantBlock label="Disabled tab">
        <Tabs defaultValue="active" className="w-[420px]">
          <TabsList>
            <TabsTrigger value="active">Active</TabsTrigger>
            <TabsTrigger value="archived" disabled>
              Archived (disabled)
            </TabsTrigger>
          </TabsList>
          <TabsContent value="active" className="pt-4 text-sm">
            5 active experiments.
          </TabsContent>
        </Tabs>
      </VariantBlock>
    </Section>
  );
}
